module.exports = "pegasus/assets/hexline-tumblr.png";